import { Spinner_default } from "./chunk-3P5HEDZF.js";
import { renderIcon } from "./chunk-6KW5RJ5F.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Link/Link.tsx
import { forwardRef, useMemo } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "a";
var LINK_CLASSNAME_MAP = {
  variant: {
    primary: "pd:link--primary",
    secondary: "pd:link--primary",
    white: "pd:link--white",
    inherit: "pd:link--inherit"
  },
  size: {
    default: "",
    sm: "pd:text-sm",
    md: "pd:text-md"
  }
};
var Link = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      variant = "primary",
      size = "default",
      iconBefore: iconBeforeProp,
      iconAfter: iconAfterProp,
      isLoading,
      screenReaderLabel,
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "variant", "size", "iconBefore", "iconAfter", "isLoading", "screenReaderLabel", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const iconBefore = useMemo(() => iconBeforeProp && renderIcon(iconBeforeProp), [iconBeforeProp]);
  const iconAfter = useMemo(() => iconAfterProp && renderIcon(iconAfterProp), [iconAfterProp]);
  return /* @__PURE__ */jsxs(Component, __spreadProps(__spreadValues({
    ref,
    className: clsx("pd:link", LINK_CLASSNAME_MAP.variant[variant], LINK_CLASSNAME_MAP.size[size], className)
  }, rest), {
    children: [screenReaderLabel && /* @__PURE__ */jsx("span", {
      className: "pd:sr-only",
      children: screenReaderLabel
    }), !isLoading && iconBefore, isLoading && /* @__PURE__ */jsx(Spinner_default, {}), children, iconAfter]
  }));
});
var StoryLink = args => /* @__PURE__ */jsx(Link, __spreadValues({}, args));
var Link_default = Link;
export { LINK_CLASSNAME_MAP, StoryLink, Link_default };